import { render, staticRenderFns } from "./report_destructor.vue?vue&type=template&id=2e265ea0&scoped=true&"
import script from "./report_destructor.vue?vue&type=script&lang=js&"
export * from "./report_destructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e265ea0",
  null
  
)

export default component.exports